import {Form, Input, message, Modal, ModalProps, Radio, Spin} from 'antd';
import React, {useEffect} from 'react';
import Style from './index.module.scss';
import {
    getTagOptions,
    saveTag,
    saveTagForm,
    saveTagType,
    TagType,
} from '../../service';
import {useMutation} from 'react-query';
import {useWatch} from 'antd/es/form/Form';
import ColorPick from '../../../../../Components/FormComponents/ColorPick';
import SelectDict from '../../../../../Features/Select/SelectDict';
import useRequest from '../../../../../Utils/Hooks/useRequest';
import {isEmpty} from '../../../../../Stores/commonStore';
import RulesAntd from '../../../../../Utils/rulesAntd';
import {useDict} from '../../dict';
import lodash from 'lodash-es';

export enum TagForm {
    Tag = 'tag',
    Type = 'type',
}
interface Props extends ModalProps {
    id?: string;
    defaultData?: saveTagForm;
    isTag?: boolean;
    onOk: () => void;
}

const Index = ({id, defaultData, onOk, isTag, ...props}: Props) => {
    const [form] = Form.useForm<saveTagForm>();
    const formType = useWatch('type', form);
    const [options, {loading}] = useRequest(getTagOptions);

    const onSaveType = useMutation({
        mutationFn: saveTagType,
        onSuccess: () => {
            message.success('成功!');
            onOk();
        },
    });

    const onSaveTag = useMutation({
        mutationFn: saveTag,
        onSuccess: () => {
            message.success('成功!');
            onOk();
        },
    });

    function onFinish(formData: saveTagForm) {
        if (id && !isTag) {
            formData.id = id;
        }
        if (formType === TagForm.Type) {
            onSaveType.mutate(formData);
        }
        if (formType === TagForm.Tag) {
            formData.catalog = lodash.find(
                options,
                item => item.id === formData?.typeId,
            )?.catalog;
            onSaveTag.mutate(formData);
        }
    }

    useEffect(() => {
        if (isTag) {
            return form.setFieldValue('type', TagForm.Tag);
        }
        if (defaultData?.content) {
            form.setFieldValue('type', TagForm.Tag);
        } else {
            form.setFieldValue('type', TagForm.Type);
        }
    }, [defaultData?.content, isTag]);

    const dict = useDict();

    return (
        <Modal {...props} width={600} title="编辑网站" onOk={form.submit}>
            <Spin spinning={onSaveTag.isLoading || onSaveType.isLoading}>
                <div className={Style.root}>
                    <Form
                        onFinish={onFinish}
                        form={form}
                        labelCol={{span: 5}}
                        initialValues={defaultData}>
                        <Form.Item name="type" label="类型">
                            <Radio.Group disabled={!isEmpty(id)}>
                                <Radio value={TagForm.Type}>一级分类</Radio>
                                <Radio value={TagForm.Tag}>二级分类</Radio>
                            </Radio.Group>
                        </Form.Item>
                        {formType === TagForm.Type && (
                            <>
                                <Form.Item
                                    name="catalog"
                                    initialValue={TagType.Info}
                                    label="类型"
                                    rules={[RulesAntd.Required]}>
                                    <SelectDict
                                        options={dict?.TagType?.data}
                                        loading={loading}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="typeName"
                                    label="分类名称"
                                    rules={[RulesAntd.Required]}>
                                    <Input />
                                </Form.Item>
                                <Form.Item name="color" label="显示颜色">
                                    <ColorPick />
                                </Form.Item>
                            </>
                        )}
                        {formType === TagForm.Tag && (
                            <>
                                <Form.Item
                                    name="typeId"
                                    label="所属分类"
                                    rules={[RulesAntd.Required]}>
                                    <SelectDict
                                        options={options}
                                        loading={loading}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="content"
                                    label="标签名称"
                                    rules={[RulesAntd.Required]}>
                                    <Input />
                                </Form.Item>
                                <Form.Item name="description" label="说明">
                                    <Input.TextArea rows={5} />
                                </Form.Item>
                            </>
                        )}
                    </Form>
                </div>
            </Spin>
        </Modal>
    );
};

export default Index;
